// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__MyIzR","title":"SectionHeader_title__PZFBP"};